export default "__VITE_ASSET__23383f5a__"